
























import Component from "vue-class-component";
import Vue from "vue";
import OrderItem from "./module/orderItem.vue";
import moduleStore from "./store/index";
@Component({
  components: { OrderItem },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  submitId
  mounted() {
    this.submitId = this.$route.query.submitId
    this.getDetail()
  }
  async getDetail() {
    if(this.pageState.invoicDetail && this.pageState.invoicDetail.length> 0) return
    const res = await this.$http("getInvoiceDetail", {
      submitId: this.submitId,
    });
  }
  preview(item){
    this.$router.push(`/order/invoicDetail3?imgUrl=${item.invoiceExtraInfo?.imgUrls??''}&pdfUrl=${item.invoiceExtraInfo?.pdfUrl}`)
  }
}
